import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { FreeToolsFAQs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/FreeToolsFAQs';
import LimitUsageSection from 'pricing-pages-ui-components/limit-usage/LimitUsageSection';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { NavMarker } from 'react-rhumb';
import ComparePlansLink from '../../../components/common/ComparePlansLink';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { trackButtonClick } from '../../../v2/utils/tracking/trackingEventUtils';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { useIsInAppAuth } from '../../hooks/user/useUserInfo';
import { FreeToolsFeatureTable } from './FreeToolsFeatureTable';
import { FreeToolsMerchCards } from './FreeToolsMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CORE_SEATS_API_NAMES = ['hubspot-free', 'crm-suite-starter-bundle'];
export const FreeToolsPage = () => {
  const isInApp = useIsInAppAuth();
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "FREE_TOOLS_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "crm",
      apiNames: CORE_SEATS_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.crm.pageTitle"
        })
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.crm.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FreeToolsMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "crm"
      })
    }), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(LimitUsageSection, {
      isFreePortal: true,
      earlyRequestName: "LIMIT_USAGE",
      useCompactGrid: true,
      onExpandButtonClick: () => trackButtonClick({
        name: 'limitInteraction',
        action: 'clicked to expand limit cards section'
      }),
      onCollapseButtonClick: () => trackButtonClick({
        name: 'limitInteraction',
        action: 'clicked to collapse limit cards section'
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FreeToolsFeatureTable, {
        isInApp: isInApp
      })
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "crm"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FreeToolsFAQs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "crm-footer",
      screen: "crm",
      apiName: "crm-suite-starter-bundle"
    })]
  });
};